import { connect } from "react-redux";
import DashboardMainTopNavbar from "../layouts/DashboardMainTopNavbar";
import { useLocation, useNavigate } from "react-router-dom";
import '../components/Home.css';

import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { DASHBOARD_LEFT, WIDTH_DASHBOARD_LEFT } from "../models/Constants";
import { useEffect, useState } from "react";
import UserList from "./userManagement/UserList";
import TestList from "./testManagement/TestList";
import SettingPage from "./settingManagement/SettingPage";
//#endregion

//#region Props
export type HomeProps = 
    ReturnType<typeof mapStateToProps> 
    & ReturnType<typeof mapDispatchToProps>
//#endregion

export const Home = (props: HomeProps) => {
    //#region Fields
    const {
      
    } = props;

    const {
       
    } = props;

    const location = useLocation();

    const isTestList = location.state && location.state?.isTestList;
    const isUserList = location.state && location.state?.isUserList;
    const isSetting = location.state && location.state?.isSetting;
   
    const [openTestList, setOpenTestList] = useState(isTestList? isTestList :true)
    const [openUserList, setOpenUserList] = useState(isUserList? isUserList :false)
    const [openSetting, setOpenSetting] = useState(isSetting? isSetting :false)
    const [defaultPage, setDefaultPage] = useState(false)

    const navigate = useNavigate();

    useEffect(() => {
        const handleBeforeUnload = (event:any) => {
            event.preventDefault()
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [navigate]);

    const handleClickOpenTestList = () => {
        setDefaultPage(!defaultPage)
        setOpenTestList(true)
        setOpenUserList(false)
        setOpenSetting(false)
    }

    const handleClickOpenUserList = () => {
        setOpenTestList(false)
        setOpenUserList(true)
        setOpenSetting(false)
    }

    const handleClickOpenSetting = () => {
        setOpenTestList(false)
        setOpenUserList(false)
        setOpenSetting(true)
    }

	return (
        <>
        <div style={{display:"flex", minHeight:"100vh", flexDirection:"column"}}>
            {(false) && (
                <div style={{ top: "0px", left: '0px', position: "fixed", zIndex: 1500, width: '100%', height: '100%', padding: '50vh 50% 50% 50%', background: '#00000030' }}>
                    <CircularProgress />
                </div>
            )}
            <DashboardMainTopNavbar userId={[]}/>
            <Stack position='relative'>
                <Stack position='absolute' style={{ width: WIDTH_DASHBOARD_LEFT,height: 'calc(100vh - 56px)',borderRight:'1px solid black', backgroundColor: DASHBOARD_LEFT }} >
                    <Box height='calc(100vh - 52px)' >
                        <Box>
                            <Button variant="text" sx={{justifyContent:"center",color:openTestList?'':"gray",width:WIDTH_DASHBOARD_LEFT,marginTop:"20px" ,height:'50px',"&:hover": {color:"blue" }, fontSize:openTestList?18:16}}
                            onClick={handleClickOpenTestList}
                            >
                                テスト実施管理
                            </Button>
                        </Box>
                        <Box>
                            <Button variant="text" sx={{justifyContent:"center",color:openUserList?'':"gray",width:WIDTH_DASHBOARD_LEFT,marginTop:"20px" ,height:'50px',"&:hover": {color:"blue" }, fontSize:openUserList?18:16}}
                            onClick={handleClickOpenUserList}
                            >
                                受検者管理
                            </Button>
                        </Box>
                        <Box>
                            <Button variant="text" sx={{justifyContent:"center",color:openSetting?'':"gray",width:WIDTH_DASHBOARD_LEFT,marginTop:"20px" ,height:'50px',"&:hover": {color:"blue" }, fontSize:openSetting?18:16}}
                            onClick={handleClickOpenSetting}
                            >
                                設定管理
                            </Button>
                        </Box>
                    </Box>
                </Stack>
                {openTestList && <TestList defaultPage={defaultPage}/>}
                {openUserList && <UserList/>}
                {openSetting && <SettingPage/>}
            </Stack>
        </div>
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        
    };
};
const mapDispatchToProps = (dispatch: any) => {
    return {
        
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Home);
